export const getOrderQueryDirection = (ordering) => {
  if (ordering.direction === "ascend") {
    return ordering.column;
  } else {
    return `-${ordering.column}`;
  }
}

export const handleOrdering = (sorter, ordering, setOrdering) => {
  const selectedColumn = sorter?.column?.orderingName;

  if (!selectedColumn) {
    setOrdering(null);
    return;
  }

  const column = ordering?.column;
  const direction = ordering?.direction;

  let selectedDirection;

  if (selectedColumn === column) {
    selectedDirection = direction === "ascend" ? "descend" : "ascend";
  } else {
    selectedDirection = "ascend";
  }

  setOrdering({
    column: selectedColumn,
    direction: selectedDirection
  })
}

export const getColumns = (columns, ordering) => {
  const orderingColumn = ordering?.column;
  const direction = ordering?.direction;

  const displayableColumns = columns.filter(column => column.display);

  return displayableColumns.map(column => {
    const orderingName = column.orderingName;
    const sortOrder = orderingColumn === orderingName ? direction : null;

    return {
      title: column.title,
      dataIndex: column.dataIndex,
      render: column.render,
      sorter: !!orderingName,
      orderingName: orderingName,
      sortOrder: sortOrder,
    }
  });
}